import { useTranslation } from "react-i18next";
import env from "../../utils/env";
import { IAppealHipProps } from "../../model/interface";
import { CaptchaControl } from "uicomponents";
import './AppealHip.scss';

export default function AppealHip(props: IAppealHipProps) {

    const { t } = useTranslation();
    return (
        <div >
            <div className="form-overview">
                <h1 className="form-overview__header"> {props.header}</h1>
            </div>
            {props.hipSolved &&
                <p className="form-overview__paragraph" data-testid="hipCompleted">
                    {t('Appeal.Common.hip-complete')} 
                </p>
            }
            {!props.hipSolved &&
                <CaptchaControl onVerification={props.handleCaptchaSubmit} baseUrl={env.REACT_APP_API_URL} />
            }
        </div>
    )
}